import React from 'react';
import { Button, Snackbar } from '@mui/material';
import useVersionCheck from '../../hooks/useVersionCheck';

/** Prompts the user to reload when a newer version of the app has been deployed. */
export default function NewVersionNotice() {
    const { updateAvailable, reload } = useVersionCheck();

    return (
        <Snackbar
            open={updateAvailable}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            message="A new version of XSifter is available."
            action={<Button color="inherit" size="small" onClick={reload}>Reload</Button>}
        />
    );
}
